import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["authentication"];

  previous() {
    const type = this.authenticationTarget.dataset.previousType;
    const current = this.authenticationTarget.dataset.current;
    const to = this.authenticationTarget.dataset.previousTo;

    if (type === 'url') {
      window.location = to;
    }
    else {
      let previousEl = document.getElementById(to);
      let currentEl = document.getElementById(current);

      previousEl.classList.toggle('hidden');
      currentEl.classList.toggle('hidden');

      this.updateNavigation(
        previousEl.dataset.previousStepType,
        to,
        previousEl.dataset.previousStep
      );
    }
  }

  updateNavigation(type, current, previous) {
    this.authenticationTarget.dataset.previousType = type;
    this.authenticationTarget.dataset.current = current;
    this.authenticationTarget.dataset.previousTo = previous;
  }
}